const lessonPlans = {
  pageTitle: 'पाठ योजना',
  pageSubtitle: 'एक व्यक्तिगत पाठ योजना डिज़ाइन और संरचना करें',
  backToDashboard: 'डैशबोर्ड पर वापस जाएं',
  planSettings: 'योजना सेटिंग्स',
  planType: 'योजना प्रकार',
  individual: 'व्यक्तिगत',
  group: 'समूह',
  targetStudents: 'लक्षित छात्र',
  selectStudents: 'छात्र चुनें...',
  noStudentsFound: 'कोई छात्र नहीं मिला',
  selectedCount: '{{count}} चयनित',
  dateRange: 'तिथि सीमा',
  startDate: 'आरंभ तिथि',
  endDate: 'समाप्ति तिथि',
  themeTopic: 'थीम / यूनिट विषय',
  themePlaceholder: 'जैसे, सामुदायिक सहायक, शरद ऋतु',
  themeHelper: 'सीखने के माहौल को संदर्भ प्रदान करता है',
  skillGoalSection: 'कौशल, लक्ष्य और उद्देश्य चयन',
  skillDomain: 'कौशल / डोमेन',
  skillDomainDesc: 'लक्षित सभी प्राथमिक विकासात्मक क्षेत्रों का चयन करें',
  noSkillsSelected: 'कोई कौशल चयनित नहीं',
  goalsAndTargets: 'लक्ष्य और उद्देश्य',
  longTermGoal: 'दीर्घकालिक लक्ष्य',
  longTermGoalPlaceholder: 'जैसे, छात्र सत्र के अंत तक स्वतंत्र रूप से व्यक्तिगत स्वच्छता दिनचर्या का प्रबंधन करेगा।',
  shortTermObjective: 'अल्पकालिक उद्देश्य',
  shortTermObjectivePlaceholder: 'जैसे, छात्र केवल मौखिक संकेतों से 5 में से 4 बार हाथ धोएगा।',
  learningProfiles: 'सीखने की प्रोफाइल और संसाधन',
  learningStylesTargeted: 'लक्षित सीखने की शैलियाँ',
  learningStylesDesc: 'छात्र(ओं) का सबसे अच्छा समर्थन करने वाले दृष्टिकोण चुनें',
  noStylesSelected: 'कोई सीखने की शैली चयनित नहीं',
  tlmMaterials: 'शिक्षण और सीखने की सामग्री (TLM)',
  tlmDesc: 'मानक सामग्री चुनें और कस्टम आइटम जोड़ें',
  standardMaterials: 'मानक सामग्री',
  customMaterials: 'कस्टम सामग्री',
  addCustomMaterial: 'जोड़ने के लिए टाइप करें और Enter दबाएं',
  noMaterialsSelected: 'कोई सामग्री चयनित नहीं',
  procedureSection: 'बहु-चरणीय प्रक्रिया',
  procedureDesc: 'कार्यों को सूक्ष्म-चरणों में विभाजित करें (कार्य विश्लेषण)',
  addStep: 'चरण जोड़ें',
  removeStep: 'चरण हटाएं',
  stepNumber: 'चरण {{number}}',
  stepTitle: 'चरण शीर्षक',
  stepTitlePlaceholder: 'जैसे, वार्म-अप / ध्यान केंद्रित करना',
  educatorAction: 'शिक्षक कार्रवाई',
  educatorActionPlaceholder: 'शिक्षक क्या कहता है या करता है...',
  studentExpectation: 'छात्र अपेक्षा',
  studentExpectationPlaceholder: 'छात्र को कैसे प्रतिक्रिया देनी चाहिए...',
  promptHierarchy: 'संकेत पदानुक्रम स्तर',
  noProcedureSteps: 'अभी तक कोई प्रक्रिया चरण नहीं जोड़ा गया। शुरू करने के लिए "चरण जोड़ें" पर क्लिक करें।',
  evaluationSection: 'मूल्यांकन और ट्रैकिंग',
  evaluationDesc: 'इस पाठ के भीतर कई विशिष्ट व्यवहारों या माइलस्टोन को ट्रैक करें',
  addMetric: 'मीट्रिक जोड़ें',
  removeMetric: 'मीट्रिक हटाएं',
  metricNumber: 'मीट्रिक {{number}}',
  targetBehavior: 'लक्षित व्यवहार',
  targetBehaviorPlaceholder: 'जैसे, आँख से संपर्क, सही छँटाई',
  measurementCriteria: 'मापन मानदंड',
  successThreshold: 'सफलता सीमा',
  successThresholdPlaceholder: 'जैसे, लगातार 3 दिनों में 80% सटीकता',
  noEvaluationMetrics: 'अभी तक कोई मूल्यांकन मीट्रिक नहीं जोड़ा गया। शुरू करने के लिए "मीट्रिक जोड़ें" पर क्लिक करें।',
  continuitySection: 'निरंतरता और अंतिम समीक्षा',
  followUpPlan: 'अनुवर्ती योजना',
  followUpPlanPlaceholder: 'विभिन्न सेटिंग्स में सामान्यीकरण की रणनीतियाँ, घर पर सुदृढ़ीकरण गतिविधियाँ, या अगले तार्किक शैक्षणिक कदम...',
  finalEvaluation: 'अंतिम मूल्यांकन / सत्र नोट्स',
  finalEvaluationDesc: 'पाठ संचालित होने के बाद भरा जाना है',
  finalEvaluationPlaceholder: 'क्या काम किया, अप्रत्याशित संवेदी ट्रिगर, और समग्र जुड़ाव नोट्स कैप्चर करें...',
  saveDraft: 'ड्राफ्ट सहेजें',
  submitPlan: 'पाठ योजना जमा करें',
  planSavedDraft: 'पाठ योजना ड्राफ्ट के रूप में सहेजी गई!',
  planSubmitted: 'पाठ योजना सफलतापूर्वक जमा की गई!',
  validationSelectStudents: 'कृपया कम से कम एक छात्र चुनें',
  validationDateRange: 'कृपया आरंभ और समाप्ति दोनों तिथियाँ चुनें',
  validationTheme: 'थीम / यूनिट विषय आवश्यक है',
  validationSkillDomain: 'कृपया कम से कम एक कौशल डोमेन चुनें',
  validationLongTermGoal: 'दीर्घकालिक लक्ष्य आवश्यक है',
  validationShortTermObjective: 'अल्पकालिक उद्देश्य आवश्यक है',
  validationLearningStyles: 'कृपया कम से कम एक सीखने की शैली चुनें',
  validationProcedureSteps: 'कृपया कम से कम एक प्रक्रिया चरण जोड़ें',
  listPageTitle: 'मेरी पाठ योजनाएं',
  listPageSubtitle: 'अपनी सभी पाठ योजनाओं को देखें, प्रबंधित करें और ट्रैक करें',
  newPlan: 'नई पाठ योजना',
  saveAsTemplate: 'टेम्पलेट के रूप में सहेजें',
  saveAsTemplateTitle: 'टेम्पलेट के रूप में सहेजें',
  templateName: 'टेम्पलेट का नाम',
  templateNamePlaceholder: 'जैसे, सुबह की दिनचर्या योजना',
  templateSaved: 'टेम्पलेट सफलतापूर्वक सहेजा गया!',
  planTypeIndividual: 'व्यक्तिगत',
  planTypeGroup: 'समूह',
  statusSubmitted: 'जमा किया गया',
  statusInProgress: 'प्रगति में',
  statusCompleted: 'पूर्ण',
  noLessonPlans: 'अभी तक कोई पाठ योजना नहीं',
  noLessonPlansDesc: 'आरंभ करने के लिए अपनी पहली पाठ योजना बनाएं।',
  noTemplates: 'अभी तक कोई टेम्पलेट सहेजा नहीं गया',
  noTemplatesDesc: 'बाद में पुन: उपयोग के लिए किसी पाठ योजना को टेम्पलेट के रूप में सहेजें।',
  searchPlans: 'पाठ योजनाएं खोजें...',
  filterByStatus: 'स्थिति के अनुसार फ़िल्टर करें',
  allPlans: 'सभी योजनाएं',
  myTemplates: 'मेरे टेम्पलेट',
  duplicatePlan: 'नकल बनाएं',
  deletePlan: 'योजना हटाएं',
  deletePlanConfirm: 'क्या आप वाकई इस पाठ योजना को हटाना चाहते हैं?',
  planDeleted: 'पाठ योजना हटाई गई',
  planDuplicated: 'पाठ योजना की नकल बनाई गई',
  useTemplate: 'टेम्पलेट का उपयोग करें',
  stepsCount: '{{count}} चरण',
  metricsCount: '{{count}} मीट्रिक',
  skillsCount: '{{count}} कौशल',
};

export default lessonPlans;